import type { ReactElement } from 'react';

import { TextField } from '@/components/ui/TextField';

// Avisos de un campo propio de fecha (reunión 2026-10-27): N días antes y, aparte, una
// vez cuando la fecha pasa. Los avisos llegan al elaborador del documento y a Calidad.

export function DateReminderFields({
  days,
  overdue,
  error,
  onDaysChange,
  onOverdueChange,
}: {
  days: string;
  overdue: boolean;
  error: string | null;
  onDaysChange: (days: string) => void;
  onOverdueChange: (overdue: boolean) => void;
}): ReactElement {
  return (
    <>
      <TextField
        label="Avisar días antes (opcional)"
        value={days}
        maxLength={3}
        inputMode="numeric"
        placeholder="30"
        hint="Vacío: sin aviso. El aviso llega al elaborador del documento y a Calidad."
        error={error}
        onChange={onDaysChange}
      />
      <label className="chk">
        <input
          type="checkbox"
          checked={overdue}
          onChange={(e) => onOverdueChange(e.target.checked)}
        />
        Avisar también cuando vence
      </label>
    </>
  );
}
